import { render, staticRenderFns } from "./OptionEditGroup.vue?vue&type=template&id=53e73317&scoped=true&"
import script from "./OptionEditGroup.vue?vue&type=script&lang=js&"
export * from "./OptionEditGroup.vue?vue&type=script&lang=js&"
import style0 from "./OptionEditGroup.vue?vue&type=style&index=0&id=53e73317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e73317",
  null
  
)

export default component.exports